import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import Footer from "../Component/Footer";

// 2027-28 link is a placeholder until its PDF is provided.
const plannerList = [
  {
    session: "2026-27",
  href: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/pdf/SPCS-pedagogical-planner.pdf",
  },
  { session: "2025-26", href: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/pdf/SPCS-pedagogical-planner_2025_26.pdf" },
  
];

function PedagogicalPlanner() {
  useEffect(() => {
    document.title = "Pedagogical Planner - St Peters convent School Faridabad Haryana";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li>Pedagogical Planner</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row mb-5">
            <div className="col-12">
              <h1 className="fw-bold">Pedagogical Planner</h1>
            </div>
          </div>
          <div className="row">
            {plannerList.map((item) => (
              <div className="col-lg-3 col-md-6 mb-4" key={item.session}>
                <div className="card syllabus-card h-100 text-center">
                  <div className="card-body">
                    <div className="pdf-icon mb-3">📄</div>
                    <h6 className="fw-semibold">
                      Pedagogical Planner {item.session}
                    </h6>
                   
                    <div>
                      <a
                        href={item.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="click-text"
                      >
                        Click Here →
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default PedagogicalPlanner;
